import { createI18n } from 'vue-i18n';
import zhTW from './locales/zh-TW';
import zhCN from './locales/zh-CN';
import enUS from './locales/en-US';
import jaJP from './locales/ja-JP';

const messages = {
  'zh-TW': zhTW,
  'zh-CN': zhCN,
  zh: zhCN, // Add fallback for generic 'zh' locale
  'en-US': enUS,
  'ja-JP': jaJP
};

const i18n = createI18n({
  legacy: false, // 使用 composition API
  locale: 'zh-TW', // 預設語系
  fallbackLocale: 'en-US', // 回退語系，避免 fallback 到簡體
  messages,
  globalInjection: true
});

export default i18n;
export { i18n };
